const data = [
  {
    title: "QR Code Generator",
    shortDescription:
      "Turn any text or link into a scannable square. It's how restaurants show menus without printing paper.",
    description:
      "You see these everywhere, from UPI payments to Wi-Fi logins. But do you have to write the math for those black and white squares yourself? No! This project teaches you a vital developer skill: **Using Third-Party Libraries**. We install a pre-made tool (package) from npm, pass your text into it as a 'Prop', and let it handle the drawing. It is the perfect lesson in why we don't 'reinvent the wheel' in coding.",
  },
];

export default data;